import IntroductionWithImageRow from "./IntroductionWithImageRow";

import Style from "./IntroductionWithImages.module.css";
import { useI18n } from "../../i18n/I18nContext";

const rows = [
  { imageSrc: "/road.webp", boxColor: "#003CA2" },
  { imageSrc: "/montain-peaks.webp", boxColor: "#00A2FF", reversed: true },
  { imageSrc: "/teamwork-table.webp", boxColor: "#0DA8CF" },
  { imageSrc: "/call.webp", boxColor: "#035DCB", reversed: true },
];

const IntroductionWithImagesSection = () => {
  const { copy } = useI18n();

  return (
    <div className={Style["introduction-with-images-wrapper"]}>
      {rows.map((row, index) => (
        <IntroductionWithImageRow
          key={row.imageSrc}
          {...row}
          text={copy.about.values[index]}
        />
      ))}
    </div>
  );
};

export default IntroductionWithImagesSection;
